import { TEntityOverride } from 'src/types'

const override: TEntityOverride = {
  global: {
    properties: {
      groups: {
        type: 'groups',
      },
      ptzController: {
        hidden: true,
      },
    },
  },
}

export default override
